// Tiny Web Audio beep generator — no audio assets to manage, just an
// oscillator blip. Used for the low-checkpoint-timer warning (see
// CONFIG.checkpointTimerLowSeconds); kept generic in case something else
// wants a short cue later.

let audioCtx: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (audioCtx) return audioCtx;
  const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  audioCtx = new Ctor();
  return audioCtx;
}

/** A short, sharp square-wave blip — the "checkpoint timer running low" warning tick. */
export function playWarningBeep(): void {
  const ctx = getAudioContext();
  if (!ctx) return;
  try {
    // Browsers start an AudioContext "suspended" until a user gesture — by
    // the time the timer is low, the player has already clicked/typed
    // plenty (claiming a role, moving pieces), so this just catches up.
    if (ctx.state === "suspended") void ctx.resume();

    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "square";
    osc.frequency.value = 880;
    gain.gain.setValueAtTime(0.0001, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.2, ctx.currentTime + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.18);
    osc.connect(gain).connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + 0.2);
  } catch {
    // Audio isn't essential to gameplay — never let a playback failure (autoplay policy, unsupported browser, etc.) break the render loop.
  }
}
